import React, { forwardRef } from 'react';
import { Form } from 'tea-component';
import './index.scss';

function TableContent(props: any, ref: any) {
  const { layout = 'inline', hideLabel = false, configForm } = props;
  const { form, formList } = configForm;
  // useUpdateEffect(() => {
  //   if (!handerSearch) getAllData();
  // }, [pageData.page_size, pageData.page, sorts]);

  // // 是否首次执行
  // useEffect(() => {
  //   // immediately
  //   if (immediately) getAllData();
  // }, []);

  // useImperativeHandle(ref, () => ({
  //   search: () => getAllData, // 暴露 搜索方法
  // }));
  return (
    <Form layout={layout} hideLabel={hideLabel} {...form} className="TableForm">
      {formList.map((item: any) => (
        <Form.Item key={item.key} {...item}>
          {item.render()}
        </Form.Item>
      ))}
    </Form>
  );
}
export default forwardRef(TableContent);
